import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { TooltipProvider } from "./components/ui/primitives.js";
import { useAuth } from "./state/auth.js";
import { useGame } from "./state/game.js";
import { HomePage } from "./pages/Home.js";
import { ProfilePage } from "./pages/Profile.js";
import { GamePage } from "./pages/Game.js";
import { AdminPage } from "./pages/Admin.js";
import { SignInPage } from "./pages/SignIn.js";

export function App() {
  const { status, token, init } = useAuth();
  const connect = useGame((s) => s.connect);
  const disconnect = useGame((s) => s.disconnect);

  useEffect(() => {
    void init();
  }, [init]);

  // One socket for the whole session, opened as soon as there is a token to authenticate it with.
  useEffect(() => {
    if (status === "signed_in" && token) connect(token);
    else disconnect();
  }, [status, token, connect, disconnect]);

  if (status === "loading") {
    return <div className="grid min-h-full place-items-center text-sm text-parchment-dim">Loading…</div>;
  }
  if (status !== "signed_in") return <SignInPage />;

  return (
    // Radix wants one provider for the whole tree. 250ms is long enough not to flash tooltips at
    // someone sweeping across the control bar, short enough to feel like an answer.
    <TooltipProvider delayDuration={250} skipDelayDuration={400}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/game/:code" element={<GamePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  );
}
